import React from 'react';
import TrueImpactText from '../../design-system/base/TrueImpactText';
import { FormControlLabel, Checkbox } from '@mui/material';
import { FeedbackFilter } from './FeedbackDashboardFilterBar';

interface CheckboxItemProps {
  donorName: string;
  count: number | string | undefined;
  checked: boolean | undefined;
  onClick: (checked: boolean) => unknown;
}

export const CheckboxItem: React.FC<CheckboxItemProps> = ({
  donorName,
  count,
  checked = false,
  onClick,
}) => {
  const handleChange = (_e: React.ChangeEvent<HTMLInputElement>, c: boolean) =>
    onClick(c);

  return (
    <div className="checkbox__wrapper">
      <FormControlLabel
        control={
          <Checkbox checked={checked} onChange={handleChange} color="default" />
        }
        label={
          <TrueImpactText allowTextSelection={false}>
            {donorName}
          </TrueImpactText>
        }
        color="primary"
      />
      {count !== undefined && (
        <TrueImpactText
          allowTextSelection={false}
          variant="body-small"
          className="checkbox__count"
        >
          ({count})
        </TrueImpactText>
      )}
    </div>
  );
};

interface FeedbackFilterCheckboxProps {
  id: string;
  filter: FeedbackFilter;
  handleChange: (id: string, _name: string, selected: boolean) => void;
}

const FeedbackFilterCheckbox: React.FC<FeedbackFilterCheckboxProps> = ({
  id,
  filter,
  handleChange,
}) => {
  const handleClick = (c: boolean) => {
    handleChange(id, filter.name, c);
  };
  return (
    <CheckboxItem
      checked={filter.selected}
      onClick={handleClick}
      donorName={filter.name}
      count={filter.count}
    />
  );
};

export default FeedbackFilterCheckbox;
